import React, { useEffect, useState, useRef } from 'react';
import { Col, UncontrolledCollapse } from 'reactstrap';
import { MdPictureAsPdf, MdClose } from "react-icons/md";
import Styles from './collapse-help.module.scss';
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface ILanguage {
  label: string; 
  id: number;
}

interface ICollapseHelp {
  routeHelpVisor: string;
  docs: any[];
  currentLang: ILanguage; 
}

type CollapseHelpProps = ICollapseHelp & RouteComponentProps;

const CollapseHelpComponent: React.FC<CollapseHelpProps> = ({ routeHelpVisor, docs, currentLang, history }) => {
  const closeButtonRef = useRef(null);
  const [files, setFiles] = useState<Array<any>>([]);

  useEffect(() => {

    if (docs) {
      const pdfFiles = docs.filter((file) => file.Title.split('.').pop().toLowerCase() === 'pdf');
      setFiles(pdfFiles);
    }
  }, [docs, currentLang]);

  const fileIcon = (fileName: string): any => {
    return <MdPictureAsPdf className={Styles.image} />;
  };

  const extractString = (url: string): string => {
    const parsedUrl = new URL(url);
    const site = parsedUrl.pathname.split("/")[2];
    const uniqueId = parsedUrl.searchParams.get("UniqueId");

    if (!site || !uniqueId) {
      throw new Error('Site or UniqueId not found in the URL');
    }

    return `${site}:${uniqueId}`;
  };

  const handleItemClick = (file: any) => {
    if (closeButtonRef.current) {
      closeButtonRef.current.click();
    }

    setTimeout(() => {
      redirectTo(`${routeHelpVisor}/${extractString(file.ServerRedirectedEmbedUri)}`);
    }, 300);
  };

  const redirectTo = (url: string) => {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      window.location.href = url;
    } else {
      history.push(url);
    }
  };

  return (
    <UncontrolledCollapse toggler="#toggler-help-hidden">
      <Col xs={12} md={5} lg={4} className={Styles.HelpContainer}>
        <div className={Styles.header}>
          <span>
            {currentLang.label === 'EN' ? 'General Help' : currentLang.label === 'PT' ? 'Ajuda Geral' : 'Ayuda General'}
          </span>
          <label className={Styles.close} id="toggler-help-hidden" ref={closeButtonRef}>
            <MdClose />
          </label>
        </div>
        {files.length > 0 ? (
          <ul className={Styles.documentList}>
            {files.map((file) => (
              <li key={file.UniqueId}>
                <span className={Styles.docs} onClick={() => handleItemClick(file)}>
                  {fileIcon(file.Title)}
                  {file.Title}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p>
            {currentLang.label === 'EN'
              ? 'No files available'
              : currentLang.label === 'PT'
              ? 'Nenhum arquivo disponível'
              : 'No hay archivos disponibles'}
          </p>
        )}
      </Col>
    </UncontrolledCollapse>
  );
};

export default withRouter(CollapseHelpComponent);
